<div class="order-details-overlay" *ngIf="isOpen && !state.showPaymentSuccess" (click)="onClose()">
  <div class="order-details-panel" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-content">
        <h2 class="panel-title">Order Details</h2>
        <button class="close-button" (click)="onClose()">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L11 11M1 11L11 1"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Order ID and Status -->
      <div class="order-info" *ngIf="order">
        <div class="order-id-label">ORDER ID</div>
        <div class="order-id-row">
          <span class="order-id-number">{{ order.orderId }}</span>
          <span class="status-badge" [ngClass]="getStatusClass(order.status)">
            {{ order.status.label }}
          </span>

          <!-- Three-dot menu -->
          <div class="order-actions" *ngIf="canShowActions()">
            <button
              class="action-button"
              (click)="toggleDropdown($event)"
              [class.active]="showDropdown"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8" cy="3" r="1.5" fill="#555A63" />
                <circle cx="8" cy="8" r="1.5" fill="#555A63" />
                <circle cx="8" cy="13" r="1.5" fill="#555A63" />
              </svg>
            </button>

            <!-- Dropdown Menu -->
            <!--
              CWS-1862: Refund / Cancel come from the server's cancellation flags
              (buildOrderRowActions), as on the Orders list; greyed with a hint
              when they do not apply. Feature off: today's single "Cancel Order".
            -->
            <div
              class="dropdown-menu"
              [class.dropdown-menu--actions]="order.cancellation?.available === true"
              *ngIf="showDropdown"
              (click)="$event.stopPropagation()"
              role="menu"
            >
              <div
                *ngFor="let action of menuActions; trackBy: trackAction"
                class="dropdown-item"
                [class.disabled]="!action.enabled"
                [attr.role]="'menuitem'"
                [attr.aria-disabled]="!action.enabled"
                [attr.data-action]="action.key"
                (click)="onMenuAction(action)"
              >
                <div class="dropdown-content">
                  <span class="dropdown-text">
                    <span class="dropdown-label">{{ action.label }}</span>
                    <span
                      class="dropdown-hint"
                      *ngIf="!action.enabled && action.hint"
                      [class.dropdown-hint--inline]="action.inlineHint"
                      >{{ action.hint }}</span
                    >
                  </span>
                  <svg
                    *ngIf="action.key === 'cancel'"
                    class="dropdown-icon"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M1.75 1.75L12.25 12.25"
                      stroke="#DA1E28"
                      stroke-width="1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.25 1.75L1.75 12.25"
                      stroke="#DA1E28"
                      stroke-width="1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <svg
                    *ngIf="action.key === 'refund' || action.key === 'retry_refund'"
                    class="dropdown-icon"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M5.25 3.5L2.33333 6.41667L5.25 9.33333"
                      stroke="#555A63"
                      stroke-width="1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.33333 6.41667H9.04167C10.4914 6.41667 11.6667 7.59191 11.6667 9.04167V10.5"
                      stroke="#555A63"
                      stroke-width="1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div
                class="dropdown-item"
                *ngIf="canStopRenewal()"
                (click)="onStopRenewal()"
                data-testid="order-details-stop-renewal"
              >
                <div class="dropdown-content">
                  <span class="dropdown-text">Stop Renewal</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CWS-1921: tunnel wash package, status and time (tunnel board rows only). -->
    <app-tunnel-wash-summary
      *ngIf="order?.tunnelWashStatus"
      class="odm-tunnel-wash"
      [order]="order"
    ></app-tunnel-wash-summary>

    <!-- Tabs -->
    <div class="odm-tab-view">
      <div
        class="tab-arrow tab-arrow-left"
        (click)="scrollTabs('left')"
        [class.hidden]="!canScrollLeft"
      >
        <img
          src="assets/images/sidebar/chevron-left.svg"
          alt="Previous tabs"
          class="arrow-icon arrow-icon-left"
        />
      </div>
      <div
        class="tab-arrow tab-arrow-right"
        (click)="scrollTabs('right')"
        [class.hidden]="!canScrollRight"
      >
        <img
          src="assets/images/customer/chevron-right.svg"
          alt="Next tabs"
          class="arrow-icon arrow-icon-right"
        />
      </div>
      <div class="tab-navigation">
        <div class="tab-list-container" #orderTabListContainer (scroll)="onTabScroll()">
          <div class="tab-list">
            <div
              *ngFor="let tab of tabs; trackBy: trackByIndex"
              class="tab-item"
              [class.active]="activeTab === tab.id"
              (click)="setActiveTab(tab.id)"
            >
              <div class="tab-content">
                <img
                  class="tab-icon"
                  [src]="'assets/images/' + tab.icon + '.png'"
                  [alt]="tab.label"
                />
                <span class="tab-label">{{ tab.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Area -->
    <div class="panel-content">
      <!-- Order Summary Tab -->
      <app-order-summary-tab
        *ngIf="activeTab === 'order-summary'"
        [order]="order"
        [apiOrderData]="state.apiOrderData"
      >
      </app-order-summary-tab>

      <!-- Booking Details Tab -->
      <app-customer-info-tab *ngIf="activeTab === 'customer-info'" [order]="order">
      </app-customer-info-tab>

      <!-- Vehicle Details Tab -->
      <app-vehicle-details-tab
        *ngIf="activeTab === 'vehicle-details'"
        [order]="order"
        (vehicleUpdated)="orderUpdated.emit()"
        (tabRequest)="setActiveTab($event)"
        (closeModal)="onClose()"
      >
      </app-vehicle-details-tab>

      <!-- Payment Tab -->
      <app-payment-tab
        *ngIf="activeTab === 'payment'"
        [order]="order"
        (orderUpdated)="orderUpdated.emit()"
        (paymentCompleted)="onPaymentCompleted()"
      >
      </app-payment-tab>
    </div>
  </div>
</div>

<!-- Cancel Order Modal -->
<app-cancel-order-modal
  [order]="order"
  [isOpen]="state.showCancelOrderModal"
  (close)="closeCancelOrderModal()"
  (confirm)="onCancelOrderConfirm($event)"
></app-cancel-order-modal>

<!-- CWS-1862: cancel & refund panel (CWS-1778), opened from the header menu when the feature is on -->
<app-cancel-refund-panel
  [isOpen]="showCancelRefundPanel"
  [orderId]="order?.id ?? null"
  [locationId]="order?.locationId ?? null"
  [intent]="cancelRefundIntent"
  [orderNumber]="order?.orderId ?? null"
  [customerName]="order?.customerName ?? null"
  [orderDate]="order?.dateTime ?? null"
  (closed)="closeCancelRefundPanel()"
  (done)="onCancelRefundDone($event)"
></app-cancel-refund-panel>

<!-- Stop Renewal (family plan orders) -->
<app-confirm-action-modal
  *ngIf="showStopRenewalModal"
  testId="stop-renewal-dialog"
  title="Stop renewal?"
  [message]="stopRenewalMessage"
  confirmLabel="Stop Renewal"
  busyLabel="Stopping…"
  [busy]="isStoppingRenewal"
  (confirm)="onStopRenewalConfirm()"
  (cancel)="closeStopRenewalModal()"
></app-confirm-action-modal>

<!-- Cancellation Success Modal -->
<app-order-cancellation-success-modal
  [isOpen]="state.showCancellationSuccessModal"
  [refundAmount]="state.cancellationRefundAmount"
  [isScheduledOrder]="state.cancellationWasScheduled"
  (close)="onCancellationSuccessClose()"
  (bookAgain)="onCancellationBookAgain()"
></app-order-cancellation-success-modal>

<app-success-modal
  [isVisible]="state.showPaymentSuccess"
  [data]="state.successModalData"
  (close)="onPaymentSuccessModalClose()"
  (action)="onPaymentSuccessAction()"
>
</app-success-modal>
